"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const styled_components_1 = __importDefault(require("styled-components"));
const StickyCard_1 = __importDefault(require("../StickyCard"));
const ui_1 = require("@completeanatomy/ui");
const bridge_schema_1 = require("@completeanatomy/bridge-schema");
const isEqual_1 = __importDefault(require("lodash/isEqual"));
const PlayButton_1 = require("../../atoms/PlayButton");
const hooks_1 = require("../../hooks");
const providers_1 = require("../../providers");
// Removed Manager?.ContentManager.loadFileFromUrl for Grasshopper(Browser download video and cache it by default)
// eslint-disable-next-line max-lines-per-function
function VideoCard({ identifier, image, videoLink, rect, selectedToolType, setSelectedID, setSelectedType, }) {
    var _a, _b;
    const [isPlaying, setIsPlaying] = (0, react_1.useState)(false);
    const [isOverlayPresent, setIsOverlayPresent] = (0, react_1.useState)(false);
    const videoRef = (0, react_1.useRef)(null);
    const tools = (0, providers_1.useToolsService)();
    const stickies = (0, hooks_1.useStickiesState)();
    const sticky = stickies.find(s => s.identifier === identifier);
    const selectedId = (0, hooks_1.useSelectedID)();
    (0, react_1.useEffect)(() => {
        // Function to check if Model Downloading overlay is present
        const checkOverlayPresence = () => {
            const overlayComponent = document.querySelector('[data-component="ModelDownloadingOverlay"]');
            setIsOverlayPresent(overlayComponent !== null);
        };
        checkOverlayPresence();
        const observer = new MutationObserver(checkOverlayPresence);
        observer.observe(document.body, { childList: true, subtree: true });
        if (isOverlayPresent) {
            if (videoRef.current) {
                videoRef.current.pause();
                setIsPlaying(false);
            }
        }
        // Clean up the observer on unmount
        return () => {
            observer.disconnect();
        };
    }, [isOverlayPresent]);
    const handlePlayButtonClick = () => {
        if (videoRef.current) {
            if (isPlaying) {
                videoRef.current.pause();
            }
            else {
                videoRef.current.play();
            }
            setIsPlaying(!isPlaying);
        }
    };
    const handleWrapperClick = () => {
        if (videoRef.current && isPlaying) {
            videoRef.current.pause();
            setIsPlaying(false);
        }
    };
    const onClick = (0, react_1.useCallback)(() => {
        if (setSelectedID) {
            setSelectedID(identifier);
        }
        tools === null || tools === void 0 ? void 0 : tools.getStickiesToolManager().selectSticky(identifier);
        if (selectedId !== identifier && selectedToolType !== bridge_schema_1.ToolType.None) {
            if (setSelectedType) {
                setSelectedType(bridge_schema_1.ToolType.None);
            }
        }
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [identifier, selectedId, selectedToolType, setSelectedID, setSelectedType]);
    const onResizing = (0, react_1.useCallback)((newSize) => {
        if (!tools || !identifier)
            return;
        if (!sticky)
            return;
        const { width: originalWidth, height: originalHeight } = sticky.stickyRect;
        let adjustedWidth = newSize.width;
        let adjustedHeight = newSize.height;
        if (newSize.width !== originalWidth) {
            adjustedHeight = (newSize.width * originalHeight) / originalWidth;
            adjustedWidth = newSize.width;
        }
        else if (newSize.height !== originalHeight) {
            adjustedWidth = (newSize.height * originalWidth) / originalHeight;
            adjustedHeight = newSize.height;
        }
        tools.getStickiesToolManager().updateSticky({
            identifier,
            stickyRect: {
                width: adjustedWidth,
                height: adjustedHeight,
            },
        });
    }, [tools, identifier, sticky]);
    const onResizeEnd = (0, react_1.useCallback)((newSize) => {
        if (!sticky)
            return;
        const { width: originalWidth, height: originalHeight } = sticky.stickyRect;
        let adjustedWidth = newSize.width;
        let adjustedHeight = newSize.height;
        if (newSize.width !== originalWidth) {
            adjustedHeight = (newSize.width * originalHeight) / originalWidth;
        }
        else {
            adjustedWidth = (newSize.height * originalWidth) / originalHeight;
        }
        tools === null || tools === void 0 ? void 0 : tools.getStickiesToolManager().updateSticky({
            identifier,
            stickyRect: {
                width: adjustedWidth,
                height: adjustedHeight,
            },
        });
    }, [tools, identifier, sticky]);
    return ((0, jsx_runtime_1.jsx)(StyledStickyCard, { identifier: identifier, rect: rect, canDrag: true, onClick: onClick, onDoubleClick: onClick, onResizing: onResizing, onResizeEnd: onResizeEnd, "data-e2e": 'VideoCard_StyledStickyCard', children: (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(PlayButtonWrapper, { onClick: handleWrapperClick, "data-e2e": 'VideoCard_PlayButtonWrapper', children: (0, jsx_runtime_1.jsx)(PlayButton_1.PlayButton, { isPlaying: isPlaying, onClick: handlePlayButtonClick, "data-e2e": 'VideoCard_PlayButton' }) }), (0, jsx_runtime_1.jsx)(StyledVideo, { ref: videoRef, 
                    //src={fixRelativeUrl(videoURL)}
                    poster: (0, ui_1.fixRelativeUrl)(image), "data-e2e": 'VideoCard_StyledVideo', children: (0, jsx_runtime_1.jsx)("source", { src: (0, ui_1.fixRelativeUrl)(videoLink), type: "video/mp4", "data-e2e": 'VideoCard_source' }) })] }) }, `${(_a = sticky === null || sticky === void 0 ? void 0 : sticky.stickyRect) === null || _a === void 0 ? void 0 : _a.x}-${(_b = sticky === null || sticky === void 0 ? void 0 : sticky.stickyRect) === null || _b === void 0 ? void 0 : _b.y}`));
}
exports.default = (0, react_1.memo)(VideoCard, (prevProps, nextProps) => {
    return (0, isEqual_1.default)(prevProps, nextProps);
});
const StyledStickyCard = (0, styled_components_1.default)(StickyCard_1.default) `
  padding: 0;
`;
const PlayButtonWrapper = styled_components_1.default.div `
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;

  z-index: 9;
`;
const StyledVideo = styled_components_1.default.video `
  width: 100%;
  height: 100%;
`;
